import { getAuth } from 'firebase/auth'
import { kAgencyDocumentsApiBasePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { getFileNameFromContentDisposition } from '@/util/api/content-disposition'
import { ApiError } from '@/util/errors/api-error'

/**
 * Downloads an indexed government document's saved PDF, plain-text, or Markdown original, verified by
 * the API before it is sent.
 * @param documentId The Metascraper document-version ID from an MCP source link.
 * @param signal Cancels the request when the page changes documents.
 * @returns The original's bytes and the server-provided filename, if any.
 */
export async function getAgencyDocumentOriginalById(documentId: string, signal?: AbortSignal): Promise<{ blob: Blob; fileName: string | null }> {
  const token = await getAuth().currentUser?.getIdToken()
  if (!token) throw new Error('User not authenticated')
  const response = await fetch(`${kPaxtonAppApiRESTBaseUrl()}${kAgencyDocumentsApiBasePath}/${encodeURIComponent(documentId)}/original`, {
    signal,
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!response.ok) throw new ApiError(response.status, 'Original document is unavailable')
  return { blob: await response.blob(), fileName: getFileNameFromContentDisposition(response.headers.get('Content-Disposition')) }
}
